import * as motion from "motion/react-m";
import styles from "./GridContent.module.scss";
import { useGrid } from "../Grid";
import { ReactNode } from "react";
import { AnimatePresence } from "motion/react";

interface GridContentProps {
  children: ReactNode;
  rowGap?: string;
  columnGap?: string;
  gap?: string;
  justifyContent?: "center";
}

const GridContent = ({
  children,
  rowGap,
  columnGap,
  gap = "1rem",
  justifyContent = "center",
}: GridContentProps) => {
  const { loading, items, labels } = useGrid();

  return (
    <>
      <motion.div
        className={styles["grid-wrapper"]}
        aria-busy={loading ? "true" : "false"}
        style={
          {
            "--grid-row-gap": rowGap ?? gap,
            "--grid-column-gap": columnGap ?? gap,
            "--justify-content": justifyContent,
          } as React.CSSProperties
        }
      >
        <span className="is-sr-only" aria-live="polite">
          {loading ? "Lade Rezepte..." : ""}
        </span>

        <AnimatePresence mode="wait">
          <motion.ul className={`${styles["grid"]}`}>{children}</motion.ul>
        </AnimatePresence>
      </motion.div>

      <div className={styles["grid-alerts"]} role="alert">
        {!loading && items.length === 0 && <p>{labels?.noItems}</p>}
      </div>
    </>
  );
};

export default GridContent;
